import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Urls } from "../../../utils/constant";

import { useApi } from "../apiCall/useApi";

import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { setDoctorComboList, setFaqList } from "../../reducers/Faq/Faq.reducer";
import { getDoctorList } from "../../selectors/Faq/Faq.selector";

const COLUMN_LIST = [
  {
    field: "sr_no",
    headerName: "sr. no.",
    flex: 1,
  },
  {
    field: "question",
    headerName: "Questions",

    flex: 2,
  },
  {
    field: "answer",
    headerName: "Answers",
    flex: 2,
  },
  {
    field: "name",
    headerName: "Doctor Name",

    flex: 2,
  },
  {
    field: "status_val",
    headerName: "Status",
    flex: 1,
  },
];

const StatusList = [
  { id: 1, label: "active" },
  { id: 2, label: "In-Active" },
];

export default function useFaq() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [DoctorId, setDoctorId] = useState("");
  const [status, setStatus] = useState(1);
  const doctorList = useSelector(getDoctorList);

  const fetchFaqList = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const StatusVal = status === "All" ? 0 : status;
        const { data } = await apiPost({
          url: Urls.faqGet(),
          data: {
            doctor_id: DoctorId,
            status: StatusVal,
            page_size: row_count,
            current_page: current_page,
          },
        });
        // setting list to reducer
        dispatch(setFaqList(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, status, DoctorId]
  );

  const fetchDoctorComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getDoctorCombo(),
        data: {},
      });
      // setting list to reducer

      dispatch(setDoctorComboList(data.data));
    } catch (err) {
      console.log(err);
    }
  }, [DoctorId]);

  const finddoctorFromLabel = useCallback(
    (value) => {
      const selectedDoctorId = value
        ? doctorList.find((item) => item.label === value)?.id
        : null;
      setDoctorId(selectedDoctorId);
      return selectedDoctorId;
    },
    [doctorList]
  );

  const handleStatusChange = useCallback((e) => {
    setStatus(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    status,
    StatusList,
    DoctorId,
    finddoctorFromLabel,
    handleStatusChange,
    fetchFaqList,
    fetchDoctorComboList,
  };
}
